export const version = __packageVersion__ || "0.0.0";
